'use client';

import dynamic from 'next/dynamic';
import { TrailSearchResult } from '@alltrails/search/types/algoliaResultTypes';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import { MapProvider } from '../..';
import styles from './TrailListMap.module.scss';

export const LoadingMap = () => (
  <div className={styles.mapContainer}>
    <ShimmerContainer className={styles.shimmerContainer}>
      <div />
    </ShimmerContainer>
  </div>
);

const TrailListMap = dynamic(() => import('./TrailListMap'), {
  ssr: false,
  loading: LoadingMap
});

type DynamicTrailListMapProps = {
  isLoading?: boolean;
  trailSearchResults: TrailSearchResult[];
  exploreLink?: string;
};

const DynamicTrailListMap = ({ isLoading, trailSearchResults, exploreLink }: DynamicTrailListMapProps) => {
  if (isLoading) {
    return <LoadingMap />;
  }

  return (
    <MapProvider>
      <TrailListMap
        trailSearchResults={trailSearchResults}
        exploreLink={exploreLink}
      />
    </MapProvider>
  );
};

export default DynamicTrailListMap;
